var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoreFilters = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.875C16.5 4.97446 16.4605 5.06984 16.3902 5.14017C16.3198 5.21049 16.2245 5.25 16.125 5.25H4.125C4.02554 5.25 3.93016 5.21049 3.85984 5.14017C3.78951 5.06984 3.75 4.97446 3.75 4.875C3.75 4.77554 3.78951 4.68016 3.85984 4.60983C3.93016 4.53951 4.02554 4.5 4.125 4.5H16.125C16.2245 4.5 16.3198 4.53951 16.3902 4.60983C16.4605 4.68016 16.5 4.77554 16.5 4.875ZM19.875 0H0.375C0.275544 0 0.180161 0.0395085 0.109835 0.109835C0.0395089 0.180161 0 0.275544 0 0.375C0 0.474456 0.0395089 0.569839 0.109835 0.640165C0.180161 0.710491 0.275544 0.75 0.375 0.75H19.875C19.9745 0.75 20.0698 0.710491 20.1402 0.640165C20.2105 0.569839 20.25 0.474456 20.25 0.375C20.25 0.275544 20.2105 0.180161 20.1402 0.109835C20.0698 0.0395085 19.9745 0 19.875 0ZM12.375 9H7.875C7.77554 9 7.68016 9.03951 7.60983 9.10983C7.53951 9.18016 7.5 9.27554 7.5 9.375C7.5 9.47446 7.53951 9.56984 7.60983 9.64017C7.68016 9.71049 7.77554 9.75 7.875 9.75H12.375C12.4745 9.75 12.5698 9.71049 12.6402 9.64017C12.7105 9.56984 12.75 9.47446 12.75 9.375C12.75 9.27554 12.7105 9.18016 12.6402 9.10983C12.5698 9.03951 12.4745 9 12.375 9Z",
    fill: "#809FB8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoreFilters);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/more-filters.91e6523812673576e87edf5de0f3e3ee.svg";